import React, { useState } from "react";
import { connect } from "react-redux";
import { Card, Button, Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import { API } from "../../api";

function Login(props) {
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const myError = (msg) => {
    setError(`${msg}`);
    setTimeout(() => {
      setError("");
    }, 2000);
  };

  const handelValidate = () => {
    if (name.trim().length === 0 || password.trim().length === 0) {
      setError("Please Fill In All The Fields");
      setTimeout(() => {
        setError("");
      }, 2000);
      return false;
    }
    return true;
  };

  const handelLogin = (e) => {
    e.preventDefault();
    if (handelValidate()) {
      axios
        .post(`${API}get_token/`, { username: name, password })
        .then((res) => {
          props.addUserDetail({ token: res.data.access, username: name });
          if (props.cartLength > 0) {
            props.history.push("/order");
          } else {
            props.history.push("/");
          }
        })
        .catch((err) => {
          if (
            err.response.data.detail ===
            "No active account found with the given credentials"
          ) {
            myError("No active account found with the given credentials");
          }
        });
    }
  };
  return (
    <div className="container p-5">
      <form onSubmit={handelLogin}>
        <Card>
          <Card.Header>Login</Card.Header>
          <Card.Body>
            <div className="form-floating mb-3">
              <input
                type="text"
                className="form-control"
                id="floatingInput1"
                placeholder="username"
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                }}
              />
              <label htmlFor="floatingInput1">Username</label>
            </div>

            <div className="form-floating">
              <input
                type="password"
                className="form-control"
                id="floatingPassword2"
                placeholder="Password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
              />
              <label htmlFor="floatingPassword2">Password</label>
            </div>
            <p className="mt-3 text-decoration-underline">
              Forget Your Password ?
            </p>
            <Button type="submit" className="px-5 mb-3 " variant="dark">
              Login
            </Button>
            {error && <Alert variant="danger">{error}</Alert>}

            <div>
              <p className="text-center">
                New To <span style={{ color: "#e8491d" }}>SHOP</span>YOU ?{" "}
                <Link to="/signup" className="my_active text-decoration-none">
                  Create An Account
                </Link>
              </p>
            </div>
          </Card.Body>
        </Card>
      </form>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    cartLength: state.cart.length,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addUserDetail: (val) => dispatch({ type: "ADD_USER_DETAIL", payload: val }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
